export default __webpack_public_path__ + "static/media/txt_replay.ea147165.svg";